export default {
    PtHeaderWidgetCaseTime: {
        tooltip: 'Project Timer',
    },
};
